import { useState } from 'react';
import { TrendingUp, Award, Share2, Users, ChevronUp, Search } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './referrals.css'; // We'll define custom CSS separately
import { useSelector } from 'react-redux';
import { MdOutlineContentCopy } from 'react-icons/md';
import { LiaMedalSolid } from 'react-icons/lia';
import ReferralDetails from './ReferralDetails';
import { toast } from 'react-toastify';

export default function ReferralContests() {
    const userDetails = useSelector((state) => state.user.user);
    const [copied, setCopied] = useState(false);
    const referralCode = userDetails?.referral_code?.code;
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const referralLink = referralCode ? `${baseUrl}/getstarted?ref=${referralCode}` : `${baseUrl}/getstarted`;

    const handleCopyLink = () => {
        navigator.clipboard.writeText(referralLink);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 5000);
    };

    return (
        <section className="leaderboard_pg">
            <div className="leaderboard-container">
                <div className="header-gradient">
                    <div className="container py-2">
                        <h6>Your referral code: <span className="text-white">{referralCode}</span></h6>

                        <div className="text-center my-1 d-flex align-items-center justify-content-start gap-3">
                            <button
                                className="btn btn-info btn-sm share-btn"
                                onClick={() => {
                                    if (navigator.share) {
                                    navigator.share({
                                        title: 'Join me on CardPlot!',
                                        text: 'Use my referral link to get started:',
                                        url: referralLink,
                                    }).catch((err) => {
                                        // console.error('Error sharing:', err);
                                    });
                                    } else {
                                        handleCopyLink();
                                        toast.warning('Sharing is not supported on this browser. Link copied to clipboard instead!');
                                    }
                                }}
                                >
                                <Share2 size={18} className="me-2" />
                                Share Your Referral link
                            </button>
                            <div className="d-flex align-items-center gap-2">
                                {/* <span className="mb-0">Copy</span> */}
                                <div className="position-relative">
                                    <div className="copy-icon" title='Copy Referral Link'>
                                        <div className="position-relative">
                                            <MdOutlineContentCopy role="button" size={20} color="#fff" onClick={handleCopyLink} />
                                            {/* Tooltip */}
                                            {copied && (
                                                <div className="copy-tooltip text-white p-2 rounded small">
                                                    Copied!
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="row mt-4">
                            <div className="col-md-4">
                                <div className="stat-card">
                                    <div className="d-flex align-items-center mb-2">
                                        <Award className="me-2" size={20} />
                                        <h6 className="fw-semibold mb-0">Your Current Rank</h6>
                                    </div>
                                    <p className="fs-1 fw-bold mb-0">#{userDetails?.rank || 0}</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="stat-card">
                                    <div className="d-flex align-items-center mb-2">
                                        <TrendingUp className="me-2" size={20} />
                                        <h6 className="fw-semibold mb-0">Your Total Points</h6>
                                    </div>
                                    <p className="fs-1 fw-bold mb-0">{userDetails?.referral_points}</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="stat-card">
                                    <div className="d-flex align-items-center mb-2">
                                        <Users className="me-2" size={20} />
                                        <h6 className="fw-semibold mb-0">Your Total Referrals</h6>
                                    </div>
                                    <p className="fs-1 fw-bold mb-0">{userDetails?.referral_count}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container py-4 mt-4">
                    <div className="reward-tiers p-4">
                        <h2 className="fw-bold mb-4"> Reward Allocations </h2>
                        <div className="row">
                            <ReferralRewardItem 
                                contestantPosition="1st Position"
                                amount="₦300,000"
                                bgColor="gold-reward"
                            />
                            <ReferralRewardItem 
                                contestantPosition="2nd Position"
                                amount="₦200,000"
                                bgColor="silver-reward"
                            />
                            <ReferralRewardItem 
                                contestantPosition="3rd Position"
                                amount="₦100,000"
                                bgColor="bronze-reward"
                            />
                            <ReferralRewardItem 
                                contestantPosition="4th - 15th"
                                amount="₦50,000 each"
                                bgColor="cyan-reward"
                            />
                        </div>
                    </div>
                </div>

                <section className="container my-5" style={{ maxWidth: '800px' }}>
                    <h2 className="fw-bold text-center mb-4">Leaderboard Reward & Referral System</h2>
                    <ReferralDetails />
                </section>

            </div>
        </section>
    );
}

const ReferralRewardItem = ({contestantPosition, amount, bgColor}) => {
    return (
        <div className="col-md-3 mb-3">
            <div className={`reward-card ${bgColor}`}>
                <div className="d-flex flex-column justify-content-center gap-1 align-items-center mb-2">
                    <LiaMedalSolid className="" size={30} />
                    <h3 className="fw-bold mb-0 d-flex align-items-center">
                        {contestantPosition}
                    </h3>
                </div>
                <p className='text-center'> {amount} </p>
            </div>
        </div>
    )
}